<template>
  <div>
    <v-sheet class="mb-4 calendario-header">
      <v-row cols="12" class="d-flex calendario-header-row">
        <v-col cols="12" md="8" sm="12" xs="12" :class="{
          'd-flex': true,
          'justify-start': $vuetify.breakpoint.name !== 'xs',
          'justify-center': $vuetify.breakpoint.name === 'xs',
          'align-center': true,
        }">
          <v-btn outlined color="grey darken-2" class="mr-4" @click="setToday">
            Hoje
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <h3 v-if="cal">{{ cal.title }}</h3>
        </v-col>
        <v-col :class="{
          'd-flex': true,
          'justify-end': $vuetify.breakpoint.name !== 'xs',
          'justify-center': $vuetify.breakpoint.name === 'xs',
          'align-center': true,
        }" cols="12" md="4" sm="12" xs="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" dense icon @click="gerarImpressoAgenda()" :color="corEspecialidade">
                <v-icon dense>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>Imprimir Agenda</span>
          </v-tooltip>
          <v-overlay :value="loading" opacity="0.9" class="d-flex flex-column justify-center align-center" absolute>
            <v-card class="pa-6 text-center" elevation="6" width="300">
              <v-progress-circular indeterminate size="40" color="primary" class="mb-4"></v-progress-circular>
              <h3 class="mb-2">Gerando Impresso da Agenda</h3>
              <span class="text-subtitle-2 text-grey-lighten-3">Por favor, aguarde alguns instantes...</span>
            </v-card>
          </v-overlay>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" dense icon @click="$emit('abrirModalBuscarAgendamento')"
                :color="corEspecialidade">
                <v-icon dense>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>Buscar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" dense icon @click="$emit('abrirConfiguracao')" class="ml-2 mr-2"
                :color="corEspecialidade">
                <v-icon dense>mdi-cog</v-icon>
              </v-btn>
            </template>
            <span>Configurações</span>
          </v-tooltip>

          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dense outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Dia</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mês</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-sheet>
    <v-sheet class="altura">
      <v-calendar color="success" ref="calendar" locale="pt-BR" v-model="value" :short-intervals="false" :type="type"
        :style="{ '--cor-de-fundo': corDeFundo }" :events="type !== 'month' ? events : []" :event-overlap-threshold="0"
        :interval-minutes="intervalMinutes" :interval-count="intervalCount" :first-interval="firstIntervalCalendario"
        @click:more="viewDay" @change="handleCalendarChange" @mousedown:event="iniciarArraste"
        @mousedown:time="horaInicio" @mouseleave="cancelarDrag" @mousemove:time="movimentarMouse"
        @mouseup:time="finalArraste">
        <v-progress-circular v-if="loading" indeterminate color="primary" size="48" class="loading-spinner" />
        <template #day="{ date }">
          <div class="day-cell with-scroll">
            <div v-for="(agendamento, index) in obterAgendamentosDoDia(date)" :key="'agend-' + index"
              class="bolinha-indicador-container">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="bolinha-indicador" :style="{
                    backgroundColor: agendamento.tipoAgendamento === 'Compromisso'
                      ? '#84b6f4'
                      : agendamento.tipoAgendamento === 'Coletivo'
                        ? '#9E9E9E'
                        : obterCorSelecionadaEvento[agendamento.tipoConsultaId] || coresTiposConsulta[agendamento.nomeTipoConsulta] || '#84b6f4'
                  }" @click="showEvent({ event: agendamento })"></div>
                </template>
                <span>
                  {{ agendamento.tipoAgendamento === 'Consulta' ? 'Atendimento' : agendamento.tipoAgendamento ===
                    'Coletivo' ?
                  'Agendamento Coletivo' : 'Compromisso' }}
                  às {{ agendamento.horaAgendamento }}
                  {{ agendamento.tipoAgendamento === 'Consulta' ? `(${agendamento.nomeTipoConsulta})` : '' }}
                  {{ agendamento.tipoAgendamento === 'Coletivo' && agendamento.quantidadeColetivo ? `(
                  ${agendamento.quantidadeColetivo} pacientes )` : '' }}
                  {{ agendamento.tipoAgendamento === 'Consulta' && agendamento.paciente ?
                    `para ${!agendamento.paciente.usarNomeSocialComoPrincipal ? agendamento.paciente.nomeCompleto :
                      agendamento.paciente.nomeSocial}`
                    : agendamento.tipoAgendamento === 'Coletivo' && agendamento.paciente
                      ? `para ${agendamento.paciente.nomeCompleto}`
                      : agendamento.tipoAgendamento === 'Coletivo'
                        ? ''
                        : agendamento.name }}
                </span>
              </v-tooltip>
            </div>
            <div v-for="(bloqueio, index) in obterBloqueiosHorarioDoDia(date)" :key="'bloq-' + index"
              class="bolinha-indicador-container">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="bolinha-indicador-bloqueio" style="background-color: #ef5350;">
                  </div>
                </template>
                <span>
                  Bloqueio de Horário: {{ formatarNomeTipoBloqueio(bloqueio.tipoBloqueio) }}
                  às {{ bloqueio.horarioInicio }}
                </span>
              </v-tooltip>
            </div>
          </div>
        </template>
        <template v-slot:day-body="{ date }">
          <div v-if="exibirDataAtual(date)" class="v-current-time first" :style="{ top: nowY }"></div>
        </template>
        <template v-slot:interval="{ time, week, minutesToPixels, date }">
          <template v-if="verificarFeriados(date)">
            <v-sheet :color="themeDark ? '#293845' : 'blue lighten-5'" width="100%" height="100%" tile></v-sheet>
          </template>
          <template v-else-if="verificarDatasBloqueadas(date)">
            <v-sheet :color="themeDark ? '#472d2a' : 'red lighten-5'" width="100%" height="100%" tile></v-sheet>
          </template>
          <template v-else>
            <template v-for="horario in getHorarios(date, week)">
              <v-sheet v-if="horarioConfigurado(time, horario)" @click="criarAgendamento(date, time)"
                :key="horario.id + '1'" class="d-flex" :color="themeDark ? '#212121' : 'white'" width="100%" :style="{
                  'margin-top': time.substring(0, 2) === horario.horaInicio.substring(0, 2) &&
                    horario.horaFim.substring(0, 2) !== horario.horaInicio.substring(0, 2) ?
                    horario.horaInicio.substring(3, 5) === '00' ? '0' : minutesToPixels(parseInt(horario.horaInicio.substring(3, 5))) + 'px' : '0',
                }" :height="time.substring(0, 2) === horario.horaInicio.substring(0, 2) && horario.horaFim.substring(0, 2) !==
                  horario.horaInicio.substring(0, 2) ? horario.horaInicio.substring(3, 5) === '00' ?
                  '100%' : 60 - minutesToPixels(horario.horaInicio.substring(3, 5)) + 'px' : '0%'" tile>
              </v-sheet>
              <v-sheet v-if="horarioConfigurado(time, horario)" @click="criarAgendamento(date, time)"
                :key="horario.id + '2'" class="d-flex" :color="themeDark ? '#212121' : 'white'" width="100%" :height="time.substring(0, 2) > horario.horaInicio.substring(0, 2) &&
                  time.substring(0, 2) < horario.horaFim.substring(0, 2) &&
                  horario.horaFim.substring(0, 2) !== horario.horaInicio.substring(0, 2) ? '100%' : '0%'" tile>
              </v-sheet>
              <v-sheet v-if="horarioConfigurado(time, horario)" @click="criarAgendamento(date, time)"
                :key="horario.id + '3'" class="d-flex" :color="themeDark ? '#212121' : 'white'" width="100%" :height="time.substring(0, 2) === horario.horaFim.substring(0, 2) &&
                  horario.horaFim.substring(0, 2) !== horario.horaInicio.substring(0, 2) ?
                  horario.horaFim.substring(3, 5) === '00' ? '0%' :
                    minutesToPixels(horario.horaFim.substring(3, 5)) + 'px' : '0%'" tile>
              </v-sheet>
              <v-sheet v-if="horarioConfigurado(time, horario)" @click="criarAgendamento(date, time)"
                :key="horario.id + '4'" class="d-flex" :color="themeDark ? '#212121' : 'white'" width="100%" :style="{
                  'margin-top': time.substring(0, 2) === horario.horaInicio.substring(0, 2) &&
                    horario.horaFim.substring(0, 2) === horario.horaInicio.substring(0, 2) ?
                    minutesToPixels(horario.horaInicio.substring(3, 5)) + 'px' : '0',
                }"
                :height="time.substring(0, 2) === horario.horaInicio.substring(0, 2) &&
                  horario.horaFim.substring(0, 2) === horario.horaInicio.substring(0, 2) ?
                  minutesToPixels(parseInt(horario.horaFim.substring(3, 5)) - parseInt(horario.horaInicio.substring(3, 5))) + 'px' : '0%'"
                tile>
              </v-sheet>
            </template>
            <v-sheet
              v-if="!temHorarioConfiguradoParaDia(date, week) || (temHorarioConfiguradoParaDia(date, week) && !horarioConfiguradoParaHora(time, date, week))"
              :color="themeDark ? '#424242' : 'grey lighten-3'" width="100%" height="100%"
              @click="mostrarAlertaSemHorario" tile>
            </v-sheet>
          </template>
        </template>
        <template #day-label="{ past, date, day }">
          <div class="d-flex justify-space-between align-center" @click="setData(date, true)">
            <v-hover v-slot="{ hover }">
              <span :class="{
                'px-2 py-1 text-center d-flex justify-center align-center grey--text': past,
                'px-2 py-1 mb-2 text-center d-flex justify-center align-center white--text rounded-circle success': date === value,
                'px-2 py-1 mb-2 text-center d-flex justify-center align-center': !past && !exibirDataAtual(date),
                'px-2 py-1 mb-2 text-center d-flex justify-center align-center rounded-circle': exibirDataAtual(date),
                'text-center d-flex justify-center align-center on-hover rounded-circle grey lighten-1': hover
              }" :style="exibirDataAtual(date) ? 'border: 1px solid #2dcb73; ' : ''" :elevation="hover ? 12 : 2">{{ day
              }}
              </span>
            </v-hover>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="warning" dark v-bind="attrs" v-on="on" small class="mr-1" v-show="past">
                    mdi-calendar-remove
                  </v-icon>
                </template>
                <span>Data passada</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" dark v-bind="attrs" v-on="on" small class="mr-1"
                    v-show="verificarDatasBloqueadas(date)">
                    mdi-lock
                  </v-icon>
                </template>
                <span>Data bloqueada</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="blue" dark v-bind="attrs" v-on="on" small class="mr-1"
                    v-show="verificarFeriados(date)">
                    mdi-party-popper
                  </v-icon>
                </template>
                <span>Feriado</span>
              </v-tooltip>
            </div>
          </div>
        </template>
        <template #day-label-header="{ past, date, day }">
          <div class="d-flex justify-center align-center flex-column" @click="criarAgendamento(date)">
            <v-hover v-slot="{ hover }">
              <span :class="{
                'px-2 py-1 text-center d-flex justify-center align-center grey--text': past,
                'px-2 py-1 mb-2 text-center d-flex justify-center align-center white--text rounded-circle success': date === value,
                'px-2 py-1 mb-2 text-center d-flex justify-center align-center': !past && !exibirDataAtual(date),
                'px-2 py-1 mb-2 text-center d-flex justify-center align-center rounded-circle': exibirDataAtual(date),
                'on-hover rounded-circle grey lighten-1': hover,
              }" :style="exibirDataAtual(date) ? 'border: 1px solid #2dcb73; ' : ''" :elevation="hover ? 12 : 2">{{ day
              }}</span>
            </v-hover>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="warning" dark v-bind="attrs" v-on="on" small class="mr-1" v-show="past">
                    mdi-calendar-remove
                  </v-icon>
                </template>
                <span>Data passada</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" dark v-bind="attrs" v-on="on" small class="mr-1"
                    v-show="verificarDatasBloqueadas(date)">
                    mdi-lock
                  </v-icon>
                </template>
                <span>Data bloqueada</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="blue" dark v-bind="attrs" v-on="on" small class="mr-1"
                    v-show="verificarFeriados(date)">
                    mdi-party-popper
                  </v-icon>
                </template>
                <span>Feriado</span>
              </v-tooltip>
            </div>
          </div>
        </template>
        <template v-slot:event="{ event, eventSummary }">
          <div @mousedown="iniciarArraste(event)">
            <component :is="eventSummary" />
          </div>
          <v-menu open-on-hover offset-y :close-on-click="false">
            <template v-slot:activator="{ on, attrs }">
              <div class="event-container" :class="{ 'bloqueio-horario-event': event.isBloqueioHorario }"
                :style="getMergedEventStyle(event)" @click.stop="event.isBloqueioHorario ? null : showEvent({ event })">
                <div class="event-content" v-bind="attrs" v-on="on">
                  <span v-if="event.isBloqueioHorario" class="font-weight-black event-title">
                    <v-icon small color="red darken-2">mdi-lock</v-icon>
                    {{ event.name }}
                  </span>
                  <span v-else class="font-weight-black event-title">
                    {{ event.horaAgendamento }} -
                    {{ event.tipoAgendamento === 'Consulta' && event.paciente
                      ? (!event.paciente.usarNomeSocialComoPrincipal ? event.paciente.nomeCompleto :
                        event.paciente.nomeSocial)
                      : event.tipoAgendamento === 'Coletivo'
                        ? 'Agendamento Coletivo'
                        : event.name }}
                    <v-icon v-if="event.tipoAgendamento !== 'Coletivo'" small color="#ffffff" class="ml-1">
                      {{ event.agendamentoConfirmado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                  </span>
                </div>
              </div>
            </template>
            <v-card class="pa-4 menu-card" color="grey lighten-3">
              <!-- Tooltip para Bloqueio de Horário -->
              <template v-if="event.isBloqueioHorario">
                <v-chip color="red lighten-1" dark class="text-uppercase font-weight-bold mr-2">
                  <v-icon small left>mdi-lock</v-icon>
                  BLOQUEIO DE HORÁRIO
                </v-chip>
                <v-divider class="my-3"></v-divider>
                <v-card-text>
                  <p><strong>Tipo:</strong> {{ event.name }}</p>
                  <p v-if="event.descricao"><strong>Descrição:</strong> {{ event.descricao }}</p>
                  <p><strong>Início:</strong> {{ event.start.split(' ')[1] }}</p>
                  <p><strong>Fim:</strong> {{ event.end.split(' ')[1] }}</p>
                </v-card-text>
              </template>

              <!-- Tooltip para Agendamento Coletivo -->
              <template v-else-if="event.tipoAgendamento === 'Coletivo'">
                <v-chip color="grey lighten-1" dark class="text-uppercase font-weight-bold mr-2">
                  Agendamento Coletivo
                </v-chip>
                <v-divider class="my-3"></v-divider>
                <v-card-text>
                  <p><strong>Horário:</strong> {{ event.horaAgendamento }}</p>
                  <p v-if="event.quantidadeColetivo"><strong>Pacientes:</strong> {{ event.quantidadeColetivo }}</p>
                </v-card-text>
                <v-btn color="grey darken-2" dark block @click="showEvent({ event })">
                  Visualize o agendamento para detalhes
                </v-btn>
              </template>

              <!-- Tooltip para Agendamentos Normais -->
              <template v-else>
                <v-chip color="grey lighten-1" dark class="text-uppercase font-weight-bold mr-2">
                  {{ event.tipoAgendamento }}
                </v-chip>
                <v-chip :color="obterCorSituacaoAgendamento(event.situacaoAgendamento)" dark
                  class="text-uppercase font-weight-bold">
                  {{ event.situacaoAgendamento === 'Cancelado'
                    ? 'Cancelado'
                    : event.situacaoAgendamento === 'EmEspera'
                      ? 'Em Espera'
                      : event.situacaoAgendamento === 'EmAndamento'
                        ? 'Em Andamento'
                        : event.situacaoAgendamento
                  }}
                </v-chip>
                <v-divider class="my-3"></v-divider>
                <v-card-text>
                  <p v-if="event.tipoAgendamento === 'Consulta' && event.paciente">
                    <strong>Paciente:</strong>
                    {{
                      !event.paciente.usarNomeSocialComoPrincipal
                        ? event.paciente.nomeCompleto
                        : event.paciente.nomeSocial
                    }}
                  </p>
                  <p v-else-if="event.tipoAgendamento === 'Coletivo' && event.paciente">
                    <strong>Paciente:</strong>
                    {{
                      !event.paciente.usarNomeSocialComoPrincipal
                        ? event.paciente.nomeCompleto
                        : event.paciente.nomeSocial
                    }}
                  </p>
                  <p v-else-if="event.tipoAgendamento === 'Coletivo'">
                    <strong>Agendamento Coletivo</strong>
                  </p>
                  <p v-else><strong>Compromisso:</strong> {{ event.name }}</p>
                  <p v-if="event.tipoAgendamento === 'Consulta' || event.tipoAgendamento === 'Coletivo'"><strong>Tipo de
                      Consulta:</strong> {{
                        event.nomeTipoConsulta }}
                  </p>
                  <p v-if="event.observacao">
                    <strong>Observação:</strong> {{ event.observacao }}
                  </p>
                  <p><strong>Horário:</strong> {{ event.horaAgendamento }}</p>
                  <div v-if="event.tipoAgendamento === 'Consulta' || event.tipoAgendamento === 'Coletivo'">
                    <v-chip v-if="event.situacaoAgendamento === 'Cancelado'" color="red lighten-2" dark
                      class="text-uppercase font-weight-bold">
                      Agendamento Cancelado
                    </v-chip>
                    <v-chip v-else-if="event.agendamentoConfirmado" color="green lighten-2" dark
                      class="text-uppercase font-weight-bold">
                      Agendamento Confirmado
                    </v-chip>
                    <v-chip v-else color="yellow darken-1" dark class="text-uppercase font-weight-bold">
                      Agendamento Não Confirmado
                    </v-chip>
                  </div>
                </v-card-text>
              </template>
            </v-card>
          </v-menu>
        </template>
      </v-calendar>
      <ModalVisualizarAgendamento :value="modalVisualizarAgendamento" @input="handleModalVisualizarInput"
        :agendamento="selectedEvent" :loading="loading" :dialog-key="dialogKey"
        :habilitar-info-agendamento="habilitarInfoAgendamento" :desabilitar-edicao="verificaSeAgendamentoEstaCancelado"
        @confirmar="confirmarAgendamento" @editar="editarAgendamento" @excluir="clickExcluirAgendamento"
        @atualizaSituacao="atualizaSituacaoAgendamento" @pacienteEditado="recarregarAgendamento" />
      <ModalVisualizarAgendamentoColetivo :value="modalVisualizarAgendamentoColetivo"
        @input="modalVisualizarAgendamentoColetivo = $event" :agendamentos="selectedColetivoEvent.coletivoItens || []"
        :data-agendamento="selectedColetivoEvent.dataAgendamento || ''"
        :horario="selectedColetivoEvent.horaAgendamento || ''" :dialog-key="dialogKey"
        @whatsapp="confirmarAgendamentoColetivo" @editar="editarAgendamento" @excluir="excluirAgendamentoColetivo"
        @adicionar-paciente="adicionarPacienteColetivo" @ver-observacoes="mostrarObservacoesColetivo"
        @ultimo-agendamento-excluido="aoExcluirUltimoAgendamentoColetivo"
        @refresh-agendamentos-coletivo="onRefreshAgendamentosColetivo" />
      <ModalSelecionarTelefoneWhatsApp
        v-if="selectedEvent && (selectedEvent.tipoAgendamento === 'Consulta' || selectedEvent.tipoAgendamento === 'Coletivo')"
        :value="modalConfirmarAgendamento" @input="modalConfirmarAgendamento = $event"
        :paciente="selectedEvent.paciente" @abrirWhatsApp="abrirWhatsAppParaConfirmarAgendamento" />
      <modal-editar-paciente ref="modalEditarPaciente" />
    </v-sheet>
    <soi-modal-modelos-impresso-personalizado ref="ModalModeloImpressoPersonalizado"
      :fluxoParaAcionarModalModelo="fluxoParaAcionarModalModeloAgenda" @salvarModelo="aoSalvarModelo">
    </soi-modal-modelos-impresso-personalizado>
  </div>
</template>

<script lang="ts">
import Vue, { ref } from 'vue';
import DateHelper from '../../helpers/DateHelper';
import Agenda from '../../models/agenda/Agenda';
import BloqueioHorarioAgenda from '../../models/agenda/BloqueioHorarioAgenda';
import FeriadoAgenda from '../../models/agenda/FeriadoAgenda';
import Agendamento from '../../models/agendamento/Agendamento';
import Calendario from '../../models/agendamento/Calendario';
import { TipoVisualizacao } from '../../models/enums/EnumTipoVisualizacao';
import { AgendamentoService } from '../../services/AgendamentoService';
import { decode, getToken } from '../../utils/Token';
import {
  AlertaPerguntaConfirmacaoBooleano,
  AlertaPerguntaSimOuNaoBooleano, AlertaSimples, AlertaSimplesErro, MensagemMixin,
} from '@/helpers/MensagemHelper';
import { SituacaoAgendamento } from '@/models/enums/EnumSituacaoAgendamento';
import { TipoAgendamento } from '@/models/enums/EnumTipoAgendamento';
import { TipoConsultaService } from '@/services/TipoConsultaService';
import { Impresso } from '@/services/Impresso';
import PdfHelper from '@/helpers/PdfHelper';
import { AxiosResponse } from 'axios';
import { UsuarioService } from '@/services/UsuarioService';
import { PromptAssinatura } from '@/models/enums/EnumPromptAssinatura';
import { toIsoLocal } from '@/utils/formatoDatasCalendario';
import HorarioAgenda from '@/models/agenda/HorarioAgenda';
import ModalVisualizarAgendamento from './ModalVisualizarAgendamento.vue';
import ModalSelecionarTelefoneWhatsApp from './ModalSelecionarTelefoneWhatsApp.vue';
import ModalVisualizarAgendamentoColetivo from './ModalVisualizarAgendamentoColetivo.vue';
import ModalEditarPaciente from '../paciente/ModalEditarPaciente.vue';
import { CadastroCompletoHelper } from '@/helpers/CadastroCompletoHelper';
import { PacientesService } from '@/services/PacientesService';
import Role from '@/constants/enums/Role';

export default Vue.extend({
  components: {
    ModalVisualizarAgendamento,
    ModalSelecionarTelefoneWhatsApp,
    ModalVisualizarAgendamentoColetivo,
    ModalEditarPaciente,
  },
  name: 'soiCalendario',
  props: {
    agenda: {
      type: Agenda,
      required: true,
    },
    eventos: {
      type: [],
      required: true,
    },
  },
  data: () => ({
    tipoConsultaCache: {} as Record<number, { cor: string; nome: string }>,
    obterCorSelecionadaEvento: {},
    dateHelper: DateHelper,
    telefonePrincipal: 'Telefone não informado',
    telefoneSecundario: 'Telefone não informado',
    emailPrincipal: 'E-mail não informado',
    emailSecundario: '',
    ready: false,
    type: 'week',
    types: ['month', 'week', 'day'],
    typeToLabel: { month: 'Mês', week: 'Semana', day: 'Dia' },
    value: new Date(Date.now()).toISOString().substr(0, 10),
    events: [],
    selectedEvent: new Calendario(),
    selectedColetivoEvent: new Calendario(),
    mostrarComponente: true,
    componenteKey: 0,
    coresTiposConsulta: {},
    selectedElement: null,
    modalVisualizarAgendamento: false,
    modalVisualizarAgendamentoColetivo: false,
    coletivoItens: [] as Array<Agendamento>,
    modalConfirmarAgendamento: false,
    horarios: [] as Array<{ text: string; value: string }>,
    horariosAgenda: [],
    agendamentoService: new AgendamentoService(),
    agendamento: new Agendamento(),
    serviceImpresso: new Impresso(),
    periodoIncialDosAgendamentosPeloTypeDoCalendario: '',
    periodoFinallDosAgendamentosPeloTypeDoCalendario: '',
    modeloCabecalhoRodapeId: 0,
    date: DateHelper.formataParaAnoMesDia(
      new Date(Date.now()).toISOString().substr(0, 10),
    ),
    dateFormatted: DateHelper.formataParaDiaMesAno(
      new Date(Date.now()).toISOString().substr(0, 10),
    ),
    motivoBloqueio: '',
    idAgenda: 1,
    loading: false,
    dialogKey: 0,
    tipoConsultaService: new TipoConsultaService(),
    usuarioService: new UsuarioService(),
    confirmarAssinatura: false,
    dragEvent: null,
    dragTime: null,
    habilitarInfoAgendamento: true,
    ghost: null,
    permitirReagendamento: true,
    arrastando: false,
    dragStartCoords: null,
    horaAgendamentoStr: '',
    snappedStart: null,
  }),
  computed: {
    permiteCadastroAgendamentos() {
      const idToken = decode(getToken()).id;
      const roleUsuario = decode(getToken()).role;

      if (roleUsuario === Role.Admin || roleUsuario === Role.Administrador || roleUsuario === Role.AdminMedico) {
        return true;
      }

      if (idToken === this.agenda.usuarioId) {
        return true;
      }
      if (this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken)) {
        return this.agenda.agendasUsuarios.find((x: { usuarioId: string; }) => x.usuarioId === idToken).permiteCadastroAgendamentos;
      }
      return false;
    },
    intervalMinutes() {
      if (this.type === 'day' || this.type === 'week') {
        const horariosDoDia = this.configHorarioDoDia;
        if (!horariosDoDia || !horariosDoDia.intervalo) return 30;

        return this.intervaloParaMinutos(horariosDoDia.intervalo);
      }
      return 15;
    },
    intervalCount() {
      const horariosDoDia = this.configHorarioDoDia;
      if (!horariosDoDia || !horariosDoDia.horaInicio || !horariosDoDia.horaFim) {
        return (24 * 60) / this.intervalMinutes;
      }

      const minutosInicio = this.minutosDesdeMeiaNoite(horariosDoDia.horaInicio);
      const minutosFim = this.minutosDesdeMeiaNoite(horariosDoDia.horaFim);

      const duracaoTotalMin = minutosFim - minutosInicio;
      return duracaoTotalMin / this.intervalMinutes;
    },
    // #region <Métodos para o horário atual no calendar>
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? `${this.cal.timeToY(this.cal.times.now)}px` : '-10px';
    },
    // #endregion
    themeDark() {
      return this.$vuetify.theme.dark;
    },
    corDeFundo() {
      return this.$vuetify.theme.dark ? '#424242' : '#f7f7f7';
    },
    verificaSeAgendamentoEstaCancelado() {
      return this.selectedEvent.situacaoAgendamento === 'Cancelado' && this.selectedEvent.tipoAgendamento === 'Consulta';
    },
    fluxoParaAcionarModalModeloAgenda() {
      return 'Agenda';
    },
    corEspecialidade() {
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--especialidade-primary').trim();
      return primaryColor || '#2e4b9d';
    },
    dataSelecionada(): Date {
      return this.value instanceof Date ? this.value : new Date(this.value);
    },
    diaSemanaAtual(): number {
      return this.converteNumeroDataWeekdayParaGetDayDoJS[this.dataSelecionada.getDay()];
    },
    configHorarioDoDia() {
      if (!this.agenda || !this.agenda.listaHorarios) return null;

      return this.agenda.listaHorarios.find(
        (h: HorarioAgenda) => h.diaSemana === this.diaSemanaAtual,
      ) || null;
    },
    firstIntervalCalendario(): number {
      const horariosDoDia = this.configHorarioDoDia;
      if (!horariosDoDia || !horariosDoDia.horaInicio) return 0;

      const minutosInicio = this.minutosDesdeMeiaNoite(horariosDoDia.horaInicio);
      return minutosInicio / this.intervalMinutes;
    },
    converteNumeroDataWeekdayParaGetDayDoJS(): { [key: number]: number } {
      const domingo = 0;
      const segunda = 1;
      const terca = 2;
      const quarta = 3;
      const quinta = 4;
      const sexta = 5;
      const sabado = 6;
      // o weekday do V-calendar começa a semana na segunda-feira (0) e termina no domingo (6), já o getDay do JS começa no domingo (0) e termina no sábado (6)
      return {
        0: segunda,
        1: terca,
        2: quarta,
        3: quinta,
        4: sexta,
        5: sabado,
        6: domingo,
      };
    },
  },
  watch: {
    eventos: {
      immediate: true,
      handler(novosEventos) {
        this.montarEventos(novosEventos);
      },
    },
    'agenda.tipoVisualizacao': function () {
      this.buscarModoVisualizacaoAgenda();
    },
    value() {
      this.selectedOpen = false;
      this.$emit('dia', this.value);
    },
  },
  mounted() {
    this.$nextTick(async function () {
      this.ready = true;
      this.scrollToTime();
      this.updateTime();
      this.$on('agendamento-confirmado', this.escutarAgendamentoConfirmado);
    });
  },
  methods: {
    async obterTipoConsulta(tipoConsultaId?: number) {
      if (!tipoConsultaId) {
        return { cor: '#84b6f4', nome: 'Tipo de Consulta não definido' };
      }

      if (this.tipoConsultaCache[tipoConsultaId]) {
        return this.tipoConsultaCache[tipoConsultaId];
      }

      const tipoConsulta = await this.tipoConsultaService.obterPorId(tipoConsultaId);

      const data = {
        cor: tipoConsulta?.data?.cor || '#84b6f4',
        nome: tipoConsulta?.data?.descricao || 'Tipo de Consulta não definido',
      };

      this.$set(this.tipoConsultaCache, tipoConsultaId, data);
      this.$set(this.obterCorSelecionadaEvento, tipoConsultaId, data.cor);
      return data;
    },

    async montarEventos(eventosProp) {
      const eventosAgendamentos = await Promise.all(
        eventosProp.map(async (e) => {
          const normalizarTipoAgendamento = (valor) => {
            if (valor === null || valor === undefined) return '';
            if (typeof valor === 'number') {
              if (valor === 2) return 'Coletivo';
              if (valor === 1) return 'Compromisso';
              if (valor === 0) return 'Consulta';
            }
            if (typeof valor === 'string') {
              const normalizado = valor.trim().toLowerCase();
              if (normalizado.includes('coletivo') || normalizado.includes('colet')) return 'Coletivo';
              if (normalizado.includes('compromisso')) return 'Compromisso';
              if (normalizado.includes('consulta')) return 'Consulta';
              if (normalizado === '2') return 'Coletivo';
              if (normalizado === '1') return 'Compromisso';
              if (normalizado === '0') return 'Consulta';
            }
            return valor;
          };

          const tipoOriginal = e.tipoAgendamento ?? e.agendamentoConsulta?.tipoAgendamento;
          const tipoAgendamento = normalizarTipoAgendamento(tipoOriginal) || tipoOriginal;

          if (tipoAgendamento === 'Compromisso') {
            return {
              ...e,
              tipoAgendamento,
              paciente: e.paciente || e.agendamentoConsulta?.paciente,
              timed: true,
              color: '#84b6f4',
              nomeTipoConsulta: 'Compromisso',
            };
          }

          if (tipoAgendamento === 'Coletivo') {
            const tipo = await this.obterTipoConsulta(e.tipoConsultaId);
            return {
              ...e,
              tipoAgendamento,
              paciente: e.paciente || e.agendamentoConsulta?.paciente,
              timed: true,
              color: '#9E9E9E',
              nomeTipoConsulta: tipo.nome || 'Consulta',
              convenioId: e.convenioId || e.agendamentoConsulta?.convenioId,
              agendamentoConsulta: e.agendamentoConsulta,
            };
          }

          const tipo = await this.obterTipoConsulta(e.tipoConsultaId);

          return {
            ...e,
            tipoAgendamento,
            paciente: e.paciente || e.agendamentoConsulta?.paciente,
            timed: true,
            color: tipo.cor,
            nomeTipoConsulta: tipo.nome,
          };
        }),
      );

      const normalizarData = (dataAgendamento: string, start: string): string => {
        if (dataAgendamento) {
          return dataAgendamento.split('T')[0];
        }
        if (start) {
          return start.split('T')[0].split(' ')[0];
        }
        return '';
      };

      const normalizarHora = (horaAgendamento: string, start: string): string => {
        if (horaAgendamento) {
          const [h, m] = horaAgendamento.split(':');
          if (!h || !m) return horaAgendamento;
          return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
        }
        if (start) {
          const horario = start.includes('T') ? start.split('T')[1] : start.split(' ')[1];
          if (!horario) return '';
          return horario.substring(0, 5);
        }
        return '';
      };

      const coletivos = eventosAgendamentos.filter((e) => e.tipoAgendamento === 'Coletivo');
      const outros = eventosAgendamentos.filter((e) => e.tipoAgendamento !== 'Coletivo');

      const criarChaveColetivo = (item) => {
        const dataBase = normalizarData(item.dataAgendamento, item.start);
        const horaBase = normalizarHora(item.horaAgendamento, item.start);
        return `${dataBase}-${horaBase}`;
      };

      const gruposColetivos = coletivos.reduce((acc, item) => {
        const chave = criarChaveColetivo(item);

        if (!acc[chave]) {
          acc[chave] = {
            base: item,
            itens: [],
          };
        }

        acc[chave].itens.push(item);
        return acc;
      }, {} as Record<string, { base: any; itens: any[] }>);

      const eventosColetivosAgrupados = Object.values(gruposColetivos).map((grupo: { base: any; itens: any[] }) => {
        const { base, itens } = grupo;
        const dataBase = normalizarData(base.dataAgendamento, base.start);
        const horaBase = normalizarHora(base.horaAgendamento, base.start);
        const start = base.start || (dataBase && horaBase ? `${dataBase} ${horaBase}` : base.start);
        const end = base.end || start;
        return {
          ...base,
          id: `coletivo-${dataBase}-${horaBase}`,
          name: 'Agendamento Coletivo',
          paciente: null,
          color: '#9E9E9E',
          dataAgendamento: dataBase,
          horaAgendamento: horaBase,
          start,
          end,
          isColetivoGroup: true,
          coletivoItens: itens,
          quantidadeColetivo: itens.length,
        };
      });
      const eventosBloqueios = this.agenda.listaBloqueiosHorariosEspecificos.map((bloqueio) => ({
        id: `bloqueio-${bloqueio.id}`,
        name: this.formatarNomeTipoBloqueio(bloqueio.tipoBloqueio),
        start: `${bloqueio.data.split('T')[0]} ${bloqueio.horarioInicio}`,
        end: this.calcularHorarioFim(bloqueio.data, bloqueio.horarioInicio, bloqueio.duracao),
        color: '#ffcdd2',
        timed: true,
        tipoAgendamento: 'Bloqueio',
        isBloqueioHorario: true,
      }));

      const eventosSemDuplicados = [...outros, ...eventosColetivosAgrupados, ...eventosBloqueios]
        .reduce((acc, item) => {
          if (item.tipoAgendamento !== 'Coletivo') {
            const dataBase = normalizarData(item.dataAgendamento, item.start);
            const horaBase = normalizarHora(item.horaAgendamento, item.start);
            const pacienteId = item.pacienteId || item.agendamentoConsulta?.pacienteId || '';
            const chave = `${item.tipoAgendamento}-${item.id || ''}-${dataBase}-${horaBase}-${pacienteId}`;

            const jaExiste = acc.some((evt) => {
              if (evt.tipoAgendamento === 'Coletivo') return false;
              const evtData = normalizarData(evt.dataAgendamento, evt.start);
              const evtHora = normalizarHora(evt.horaAgendamento, evt.start);
              const evtPacienteId = evt.pacienteId || evt.agendamentoConsulta?.pacienteId || '';
              const evtChave = `${evt.tipoAgendamento}-${evt.id || ''}-${evtData}-${evtHora}-${evtPacienteId}`;
              return evtChave === chave;
            });

            if (!jaExiste) {
              acc.push(item);
            }
            return acc;
          }

          const dataBase = normalizarData(item.dataAgendamento, item.start);
          const horaBase = normalizarHora(item.horaAgendamento, item.start);
          const chave = `${dataBase}-${horaBase}`;
          const existente = acc.find((evt) => evt.tipoAgendamento === 'Coletivo'
            && `${normalizarData(evt.dataAgendamento, evt.start)}-${normalizarHora(evt.horaAgendamento, evt.start)}` === chave);

          if (!existente) {
            acc.push(item);
            return acc;
          }

          if (existente.isColetivoGroup && item.isColetivoGroup) {
            existente.coletivoItens = [
              ...(existente.coletivoItens || []),
              ...(item.coletivoItens || []),
            ];
            existente.quantidadeColetivo = (existente.coletivoItens || []).length;
            return acc;
          }

          if (item.isColetivoGroup) {
            const index = acc.indexOf(existente);
            if (index >= 0) acc[index] = item;
          }

          return acc;
        }, [] as any[]);

      this.events = eventosSemDuplicados;

      if (this.modalVisualizarAgendamentoColetivo && this.selectedColetivoEvent) {
        const dataBaseSelecionada = normalizarData(this.selectedColetivoEvent.dataAgendamento, this.selectedColetivoEvent.start);
        const horaBaseSelecionada = normalizarHora(this.selectedColetivoEvent.horaAgendamento, this.selectedColetivoEvent.start);
        const chaveSelecionada = `${dataBaseSelecionada}-${horaBaseSelecionada}`;

        const coletivoAtualizado = eventosSemDuplicados.find((evt) => evt.tipoAgendamento === 'Coletivo'
          && evt.isColetivoGroup
          && `${normalizarData(evt.dataAgendamento, evt.start)}-${normalizarHora(evt.horaAgendamento, evt.start)}` === chaveSelecionada);

        if (coletivoAtualizado) {
          this.selectedColetivoEvent = { ...coletivoAtualizado };
        }
      }
    },
    fecharModalAgendamento() {
      this.modalVisualizarAgendamento = false;
      this.$emit('atualizaAgenda');
    },
    handleModalVisualizarInput(value: boolean) {
      this.modalVisualizarAgendamento = value;
      if (!value) {
        this.$emit('atualizaAgenda');
      }
    },
    getEventStyle(event) {
      if (event._ghost) {
        return { backgroundColor: '#D6D7E0B3' };
      }

      let backgroundColor = '#84b6f4';

      if (event.tipoAgendamento === 'Compromisso') {
        backgroundColor = '#84b6f4';
      } else if (event.tipoAgendamento === 'Coletivo') {
        backgroundColor = '#9E9E9E';
      } else {
        backgroundColor = this.obterCorSelecionadaEvento[event.tipoConsultaId] || '#84b6f4';
      }

      return { backgroundColor };
    },
    getMergedEventStyle(event) {
      if (event._ghost) {
        return { backgroundColor: '#D6D7E0B3' };
      }
      if (event.isBloqueioHorario) {
        return { backgroundColor: '#ffcdd2' };
      }
      return this.getEventStyle(event);
    },
    escutarAgendamentoConfirmado(agendamentoConfirmado: boolean) {
      this.selectedEvent.agendamentoConfirmado = agendamentoConfirmado;
    },
    converteSTRSituacaoAgendamentoEmEnum(situacaoAgendamento: string | Number) {
      switch (situacaoAgendamento) {
        case 'Marcado':
          situacaoAgendamento = SituacaoAgendamento.Marcado;
          break;
        case 'Em Espera':
          situacaoAgendamento = SituacaoAgendamento.EmEspera;
          break;
        case 'Em Andamento':
          situacaoAgendamento = SituacaoAgendamento.EmAndamento;
          break;
        case 'Faltou':
          situacaoAgendamento = SituacaoAgendamento.Faltou;
          break;
        case 'Finalizado':
          situacaoAgendamento = SituacaoAgendamento.Finalizado;
          break;
        case 'Cancelado':
          situacaoAgendamento = SituacaoAgendamento.Cancelado;
          break;

        default:
          // eslint-disable-next-line no-alert
          return situacaoAgendamento;
      }
      return situacaoAgendamento;
    },
    converteSTRTipoAgendamentoEmEnum(tipoAgendamento: string | Number) {
      if (tipoAgendamento === 'Consulta') tipoAgendamento = TipoAgendamento.Consulta;
      else tipoAgendamento = TipoAgendamento.Compromisso;

      return tipoAgendamento;
    },
    async atualizaSituacaoAgendamento(event) {
      const proximaSituacaoEnum = event.tipoAgendamento === 'Consulta' ? SituacaoAgendamento[event.proximaSituacao] : SituacaoAgendamento[event.proximaSituacaoCompromisso];

      if (proximaSituacaoEnum === 'EmEspera' && event.tipoAgendamento === 'Consulta') {
        const pacienteId = this.selectedEvent?.paciente?.id;

        if (pacienteId > 0) {
          try {
            const pacienteService = new PacientesService();
            const pacienteResponse: any = await pacienteService.ObterDadosDoPaciente(pacienteId);
            const paciente = pacienteResponse.data || pacienteResponse;

            const { cadastroCompleto } = paciente;
            const cadastroCompletoBoolean = (cadastroCompleto as any) === true
              || (cadastroCompleto as any) === 1
              || (cadastroCompleto as any) === '1';

            const podeProsseguir = await CadastroCompletoHelper.validarCadastroCompleto(
              pacienteId,
              cadastroCompletoBoolean,
              (id: number) => {
                (this.$refs.modalEditarPaciente as any).abrirModal(id);
              },
            );

            if (!podeProsseguir) {
              this.loading = false;
              return;
            }
          } catch (error) {
            AlertaSimplesErro('Erro ao validar cadastro:', error);
            this.loading = false;
            return;
          }
        }
      }

      this.loading = true;
      try {
        if (proximaSituacaoEnum !== 'Marcado' || event.tipoAgendamento === 'Compromisso') {
          const payload = {
            usuarioId: decode(getToken()).id,
            situacao: event.tipoAgendamento === 'Consulta' ? event.proximaSituacao : event.proximaSituacaoCompromisso,
            TipoAgendamento: TipoAgendamento[event.tipoAgendamento],
            agendamentoId: this.selectedEvent.id,
          };
          await this.agendamentoService.atualizaSituacaoAgendamentoComLog(this.selectedEvent.id, payload)
            .then((res) => {
              this.selectedEvent.situacaoAgendamento = proximaSituacaoEnum;
              setTimeout(() => {
                // eslint-disable-next-line no-plusplus
                this.dialogKey++;
                this.loading = false;
                this.$emit('buscaAgendamentos', this.value);
              }, 1000);
            })
            .catch((err) => {
              let mensagem = '';

              if (err?.response?.data) {
                if (typeof err.response.data === 'string') {
                  mensagem = err.response.data;
                } else if (err.response.data.Mensagem) {
                  mensagem = err.response.data.Mensagem;
                } else if (err.response.data.message) {
                  mensagem = err.response.data.message;
                }
              }

              if (typeof mensagem === 'string' && mensagem.includes('Em Andamento')) {
                mensagem = 'Não é possível ter dois agendamentos Em Andamento para o mesmo paciente!';
              }

              if (typeof mensagem === 'string' && mensagem.includes('Em Espera')) {
                mensagem = 'Não é possível ter dois agendamentos Em Espera para o mesmo paciente!';
              }

              if (!mensagem) {
                mensagem = 'Erro ao alterar situação do agendamento.';
              }
              AlertaSimplesErro('Erro ao alterar situação', mensagem);
              this.loading = false;
            });
          if (proximaSituacaoEnum === 'Cancelado') {
            await this.agendamentoService.atualizaMotivoCancelamento(this.selectedEvent.id, event.motivoCancelamento)
              .then((res) => {
                setTimeout(() => {
                  // eslint-disable-next-line no-plusplus
                  this.dialogKey++;
                  this.loading = false;
                  this.$emit('buscaAgendamentos', this.value);
                }, 1000);
              })
              .catch((err) => {
                let mensagem = '';
                if (err?.response?.data) {
                  if (typeof err.response.data === 'string') {
                    mensagem = err.response.data;
                  } else if (err.response.data.Mensagem) {
                    mensagem = err.response.data.Mensagem;
                  } else if (err.response.data.message) {
                    mensagem = err.response.data.message;
                  }
                }

                if (typeof mensagem === 'string' && mensagem.includes('Em Andamento')) {
                  mensagem = 'Não é possível ter dois agendamentos Em Andamento para o mesmo paciente!';
                }

                if (typeof mensagem === 'string' && mensagem.includes('Em Espera')) {
                  mensagem = 'Não é possível ter dois agendamentos Em Espera para o mesmo paciente!';
                }
                if (!mensagem) {
                  mensagem = 'Erro ao cancelar agendamento.';
                }
                AlertaSimplesErro('Erro ao cancelar', mensagem);
                this.loading = false;
              });
          }
        }
      } catch (error) {
        let mensagem = '';
        if (error?.response?.data) {
          if (typeof error.response.data === 'string') {
            mensagem = error.response.data;
          } else if (error.response.data.Mensagem) {
            mensagem = error.response.data.Mensagem;
          } else if (error.response.data.message) {
            mensagem = error.response.data.message;
          }
        }

        if (typeof mensagem === 'string' && mensagem.includes('Em Andamento')) {
          mensagem = 'Não é possível ter dois agendamentos Em Andamento para o mesmo paciente!';
        }

        if (typeof mensagem === 'string' && mensagem.includes('Em Espera')) {
          mensagem = 'Não é possível ter dois agendamentos Em Espera para o mesmo paciente!';
        }
        if (!mensagem) {
          mensagem = 'Erro ao alterar situação do agendamento.';
        }
        AlertaSimplesErro('Erro ao alterar situação', mensagem);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getHorarios(date: string, week: any) {
      const diaSemana = week.find((x: { date: string; }) => x.date === date)?.weekday;
      return this.agenda.listaHorarios.filter((x: { diaSemana: any; }) => x.diaSemana === diaSemana);
    },
    abrirModalAgendamentoComHorario(tms: any) {
      const date = new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute,
      );
      this.criarAgendamento(DateHelper.formatarParaAnosMesDiaISO(date.toISOString()));
    },
    verificarDataPassada(date: string) {
      if (DateHelper.dataMenorQueHoje(date)) {
        return true;
      }
      return false;
    },
    exibirDataAtual(date: any) {
      if (DateHelper.retornaDataAtual(date)) {
        return true;
      }
      return false;
    },
    verificarDatasBloqueadas(dataParaVerificar: string): boolean {
      const dataParaVerificarTipada: Date = new Date(`${dataParaVerificar}T00:00:00`);
      let bloqueio: BloqueioHorarioAgenda | undefined;
      // eslint-disable-next-line prefer-const
      bloqueio = this.agenda.listaBloqueios
        .find((periodo: { dataInicio: string | number | Date; dataFim: string | number | Date; }) => dataParaVerificarTipada >= new Date(periodo.dataInicio)
          && dataParaVerificarTipada <= new Date(periodo.dataFim));
      if (bloqueio) {
        return true;
      }

      return false;
    },
    verificarFeriados(dataParaVerificar: string): boolean {
      let feriado: FeriadoAgenda | undefined;

      // eslint-disable-next-line prefer-const
      feriado = this.agenda.listaFeriados
        .find((feriado: { data: string | number | Date; }) => new Date(feriado.data).getDate() === new Date(`${dataParaVerificar}T00:00:00`).getDate()
          && new Date(feriado.data).getMonth() === new Date(`${dataParaVerificar}T00:00:00`).getMonth());

      if (feriado) {
        return true;
      }

      return false;
    },
    desabilitarDatas(dataParaVerificar: string): boolean {
      const data: Date = new Date(`${dataParaVerificar}T00:00:00`);

      const datasBloqueadas = this.datasBloqueadas
        .some((periodo: { dataInicio: string | number | Date; dataFim: string | number | Date; }) => data >= new Date(periodo.dataInicio)
          && data <= new Date(periodo.dataFim));

      if (datasBloqueadas) {
        return false;
      }

      const feriados = this.feriados.some((feriado: { data: string; }) => feriado.data === `${dataParaVerificar}T00:00:00`);

      if (feriados) {
        return false;
      }

      return true;
    },
    criarAgendamento(data: Date, horario: string = '') {
      if (this.permiteCadastroAgendamentos) {
        this.value = data;
        this.$emit('abrirModalAgendamento', data, horario);
      }
    },
    editarAgendamento(agendamentoId: any) {
      this.modalVisualizarAgendamento = false;

      if (this.permiteCadastroAgendamentos) {
        this.$emit('editarAgendamento', agendamentoId);
      }
    },
    adicionarPacienteColetivo(payload: any) {
      this.$emit('adicionarPacienteColetivo', payload);
    },
    async excluirAgendamentoColetivo(agendamento: any) {
      const situacao = agendamento?.situacaoAgendamento;
      const isCancelado = (typeof situacao === 'string' && situacao.toLowerCase() === 'cancelado')
        || situacao === 5;

      if (!isCancelado) {
        return;
      }

      const confirmarCancelamento = await AlertaPerguntaSimOuNaoBooleano(
        'Deseja realmente excluir esse agendamento?',
        'O agendamento será excluído, essa ação é irreversível!',
      );

      if (!confirmarCancelamento) {
        return;
      }

      try {
        await this.agendamentoService.Delete(agendamento.id);
        if (this.selectedColetivoEvent.coletivoItens) {
          const index = this.selectedColetivoEvent.coletivoItens.findIndex(
            (item: any) => item.id === agendamento.id,
          );
          if (index >= 0) {
            this.selectedColetivoEvent.coletivoItens.splice(index, 1);
          }
        }
        MensagemMixin(3000, 'success', 'Agendamento foi descartado com sucesso');
      } catch (err) {
        AlertaSimplesErro('Aviso:', err);
      }
    },
    aoExcluirUltimoAgendamentoColetivo() {
      this.modalVisualizarAgendamentoColetivo = false;
      this.$emit('atualizaAgenda');
    },
    // #region <Função para a abertura da pré visualização do agendamento>
    showEvent({ event }) {
      if (event.tipoAgendamento === 'Coletivo') {
        if (event.isColetivoGroup) {
          this.visualizarAgendamentoColetivo(event);
          return;
        }

        const normalizarData = (dataAgendamento: string, start: string): string => {
          if (dataAgendamento) {
            return dataAgendamento.split('T')[0];
          }
          if (start) {
            return start.split('T')[0].split(' ')[0];
          }
          return '';
        };

        const normalizarHora = (horaAgendamento: string, start: string): string => {
          if (horaAgendamento) {
            const [h, m] = horaAgendamento.split(':');
            if (!h || !m) return horaAgendamento;
            return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
          }
          if (start) {
            const horario = start.includes('T') ? start.split('T')[1] : start.split(' ')[1];
            if (!horario) return '';
            return horario.substring(0, 5);
          }
          return '';
        };

        const chave = `${normalizarData(event.dataAgendamento, event.start)}-${normalizarHora(event.horaAgendamento, event.start)}`;
        const coletivosMesmoHorario = this.events.filter((e) => e.tipoAgendamento === 'Coletivo'
          && `${normalizarData(e.dataAgendamento, e.start)}-${normalizarHora(e.horaAgendamento, e.start)}` === chave);

        if (coletivosMesmoHorario.length) {
          const base = coletivosMesmoHorario[0];
          const dataBase = normalizarData(base.dataAgendamento, base.start);
          const horaBase = normalizarHora(base.horaAgendamento, base.start);
          const start = base.start || (dataBase && horaBase ? `${dataBase} ${horaBase}` : base.start);
          const end = base.end || start;
          this.visualizarAgendamentoColetivo({
            ...base,
            id: `coletivo-${dataBase}-${horaBase}`,
            name: 'Agendamento Coletivo',
            paciente: null,
            color: '#9E9E9E',
            dataAgendamento: dataBase,
            horaAgendamento: horaBase,
            start,
            end,
            isColetivoGroup: true,
            coletivoItens: coletivosMesmoHorario,
            quantidadeColetivo: coletivosMesmoHorario.length,
          });
          return;
        }
      }
      this.selectedEvent = event;
      this.modalVisualizarAgendamento = true;
    },
    async recarregarAgendamento() {
      try {
        this.loading = true;
        const res = await this.agendamentoService.buscarAgendamentoPorId(this.selectedEvent.id);
        const agendamentoAtualizado = res.data;
        this.modalVisualizarAgendamento = false;

        if (agendamentoAtualizado.agendamentoConsulta?.paciente?.id) {
          const pacienteId = agendamentoAtualizado.agendamentoConsulta.paciente.id;
          const pacientesService = new PacientesService();
          const resPaciente = await pacientesService.Get(pacienteId);
          const pacienteCompleto = resPaciente.data;

          this.$set(this.selectedEvent, 'paciente', { ...pacienteCompleto });
          this.$set(this.selectedEvent, 'agendamentoConsulta', {
            ...agendamentoAtualizado.agendamentoConsulta,
            paciente: { ...pacienteCompleto },
          });
        }

        await this.$nextTick();
        this.dialogKey++;
        await this.$nextTick();
        this.modalVisualizarAgendamento = true;
      } catch (err) {
        console.error('Erro ao recarregar agendamento:', err);
        this.modalVisualizarAgendamento = true;
      } finally {
        this.loading = false;
      }
    },
    // #endregion
    visualizarAgendamentoColetivo(event) {
      this.selectedColetivoEvent = event;
      this.modalVisualizarAgendamentoColetivo = true;
    },
    confirmarAgendamentoColetivo(agendamento: any) {
      const paciente = agendamento.paciente || agendamento.agendamentoConsulta?.paciente || {};
      const telefone = agendamento.agendamentoConsulta?.telefone || paciente?.contato?.telefonePrincipal || '';
      if (telefone) {
        paciente.contato = paciente.contato || {};
        paciente.contato.telefonePrincipal = paciente.contato.telefonePrincipal || telefone;
      }
      agendamento.paciente = paciente;
      this.selectedEvent = agendamento;
      this.modalConfirmarAgendamento = true;
    },
    mostrarObservacoesColetivo(agendamento: any) {
      const observacao = agendamento.observacao || agendamento.observacaoAgendamento || '';
      const orientacoes = agendamento.orientacoesPaciente || '';
      const mensagem = [
        observacao ? `Observações do Agendamento: ${observacao}` : '',
        orientacoes ? `Orientações ao Paciente: ${orientacoes}` : '',
      ].filter(Boolean).join('\n');

      AlertaSimples('Observações', mensagem || 'Sem observações.', 'info');
    },
    obterNomePaciente(agendamento: any): string {
      const paciente = agendamento?.paciente;
      if (paciente) {
        if (paciente.usarNomeSocialComoPrincipal) {
          return paciente.nomeSocial || 'paciente';
        }
        return paciente.nomeCompleto || 'paciente';
      }
      return agendamento?.name || 'paciente';
    },
    // #region <Funções para a navegação do calendar>
    buscarModoVisualizacaoAgenda() {
      if (this.agenda.tipoVisualizacao === TipoVisualizacao.Mes) {
        this.type = 'month';
      } else if (this.agenda.tipoVisualizacao === TipoVisualizacao.Semana) {
        this.type = 'week';
      } else if (this.agenda.tipoVisualizacao === TipoVisualizacao.Dia) {
        this.type = 'day';
      } else {
        this.type = 'week';
      }
    },
    setToday() {
      this.value = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substring(0, 10);
    },
    setData(date: Date, typeDay: boolean = false) {
      this.value = date;

      if (typeDay) {
        this.type = 'day';
      }
    },
    prev() {
      this.$refs.calendar.prev();
      this.loading = true;
      this.$emit('buscaAgendamentos', this.value);
      this.loading = false;
    },
    next() {
      this.$refs.calendar.next();
      this.loading = true;
      this.$emit('buscaAgendamentos', this.value);
      this.loading = false;
    },
    // #endregion
    // #region <Funções para mostrar o horário atual no calendar>
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      if (!this.cal) return;

      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);
      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => {
        if (this.cal) {
          this.cal.updateTimes();
        }
      }, 60 * 1000);
    },
    handleCalendarChange({ start, end }) {
      this.selectedOpen = false;
      this.periodoInicialDosAgendamentosPeloTypeDoCalendario = start.date;
      this.periodoFinalDosAgendamentosPeloTypeDoCalendario = end.date;
    },
    // #endregion
    confirmarAgendamento(idAgendamento: number) {
      this.modalConfirmarAgendamento = true;
    },
    async abrirWhatsAppParaConfirmarAgendamento(data: { telefone: string }) {
      const link = await this.buscarLink();

      const linkCurto = await this.encurtarLink(link);

      const nomePaciente = this.obterNomePaciente(this.selectedEvent);
      const mensagem = `Olá ${nomePaciente},\n\nSeu agendamento com o médico está previsto para *${this.selectedEvent.dataAgendamento}* às *${this.selectedEvent.horaAgendamento}*.
      \n\nPor favor, entre no link abaixo para confirmar sua consulta:\n\u200B${linkCurto}`;

      const mensagemCodificada = encodeURIComponent(mensagem);

      window.open(`https://api.whatsapp.com/send?phone=${data.telefone}&text=${mensagemCodificada}`, 'whatsappweb');
    },
    async buscarLink(): Promise<string> {
      let linkParaConfirmarAgendamento = '';

      await this.agendamentoService.gerarLinkParaConfirmarAgendamento(this.selectedEvent.id)
        .then(
          (res: { data: { link: string; }; }) => {
            linkParaConfirmarAgendamento = res.data.link;
          },
          (err: any) => {
            AlertaSimplesErro('Aviso:', err);
          },
        );

      return linkParaConfirmarAgendamento;
    },

    async encurtarLink(url: string): Promise<string> {
      try {
        if (url && typeof url === 'string') {
          return url;
        }

        const { data: { link } } = await this.agendamentoService.gerarLinkParaConfirmarAgendamento(this.selectedEvent.id);
        return link;
      } catch (err: any) {
        AlertaSimplesErro('Aviso:', err);
        return url;
      }
    },
    obterCorSituacaoAgendamento(situacao: string) {
      switch (situacao) {
        case 'Marcado':
          return '#84b6f4';
        case 'EmEspera':
          return '#77dd77';
        case 'EmAndamento':
          return '#FFA500';
        case 'Faltou':
          return '#ff6961';
        case 'Finalizado':
          return '#c5c6c8';
        case 'Cancelado':
          return '#FFD700';
        default:
          return '#00FF7F';
      }
    },
    horarioConfigurado(time: string, horario: any): boolean {
      const [hTime, mTime] = time.split(':').map(Number);
      const [hInicio, mInicio] = horario.horaInicio.split(':').map(Number);
      const [hFim, mFim] = horario.horaFim.split(':').map(Number);

      const minutosTime = hTime * 60 + mTime;
      const minutosInicio = hInicio * 60 + mInicio;
      const minutosFim = hFim * 60 + mFim;

      return minutosTime >= minutosInicio && minutosTime < minutosFim;
    },
    temHorarioConfiguradoParaDia(date: string, week: any): boolean {
      const diaSemana = week.find((x: { date: string; }) => x.date === date)?.weekday;
      return this.agenda.listaHorarios.some((x: { diaSemana: any; }) => x.diaSemana === diaSemana);
    },
    horarioConfiguradoParaHora(time: string, date: string, week: any): boolean {
      const diaSemana = week.find((x: { date: string; }) => x.date === date)?.weekday;
      const horariosDoDia = this.agenda.listaHorarios.filter((x: { diaSemana: any; }) => x.diaSemana === diaSemana);
      return horariosDoDia.some((horario: any) => this.horarioConfigurado(time, horario));
    },
    getDiaSemana(dateStr: string): number {
      const dataStr = new Date(dateStr);
      const numeroDia = dataStr.getDay();

      return numeroDia;
    },
    horariosConfiguradosNoCalendario(time: string, date: Date): boolean {
      const diaSemana = date.getDay();
      const horariosDoDia = this.agenda.listaHorarios
        .filter((x: { diaSemana: any }) => x.diaSemana === diaSemana);

      return horariosDoDia.some((horario: any) => this.horarioConfigurado(time, horario));
    },
    mostrarAlertaSemHorario() {
      AlertaSimplesErro('Atenção!', 'O horário selecionado não está configurado na agenda');
    },
    calcularMarginTopPrimeiroSheet(time: string, horario: any, minutesToPixels: any): string {
      const timeHour = time.substring(0, 2);
      const horaInicioHour = horario.horaInicio.substring(0, 2);
      const horaFimHour = horario.horaFim.substring(0, 2);
      const horaInicioMinute = horario.horaInicio.substring(3, 5);

      if (timeHour === horaInicioHour && horaFimHour !== horaInicioHour) {
        return horaInicioMinute === '00' ? '0' : `${minutesToPixels(parseInt(horaInicioMinute, 10))}px`;
      }

      return '0';
    },
    calcularAlturaPrimeiroSheet(time: string, horario: any, minutesToPixels: any): string {
      const timeHour = time.substring(0, 2);
      const horaInicioHour = horario.horaInicio.substring(0, 2);
      const horaFimHour = horario.horaFim.substring(0, 2);
      const horaInicioMinute = horario.horaInicio.substring(3, 5);

      if (timeHour === horaInicioHour && horaFimHour !== horaInicioHour) {
        return horaInicioMinute === '00' ? '100%' : `${60 - minutesToPixels(horaInicioMinute)}px`;
      }

      return '0%';
    },
    calcularAlturaSegundoSheet(time: string, horario: any): string {
      const timeHour = time.substring(0, 2);
      const horaInicioHour = horario.horaInicio.substring(0, 2);
      const horaFimHour = horario.horaFim.substring(0, 2);

      if (timeHour > horaInicioHour && timeHour < horaFimHour && horaFimHour !== horaInicioHour) {
        return '100%';
      }

      return '0%';
    },
    calcularAlturaTerceiroSheet(time: string, horario: any, minutesToPixels: any): string {
      const timeHour = time.substring(0, 2);
      const horaInicioHour = horario.horaInicio.substring(0, 2);
      const horaFimHour = horario.horaFim.substring(0, 2);
      const horaFimMinute = horario.horaFim.substring(3, 5);

      if (timeHour === horaFimHour && horaFimHour !== horaInicioHour) {
        return horaFimMinute === '00' ? '0%' : `${minutesToPixels(horaFimMinute)}px`;
      }

      return '0%';
    },
    iniciarArraste({ event, timed, nativeEvent }) {
      if (event && timed) {
        this.dragEvent = event;
        this.habilitarInfoAgendamento = false;

        this.dragTime = null;

        this.arrastando = false;
        this.dragStartCoords = {
          x: nativeEvent.clientX,
          y: nativeEvent.clientY,
        };
      }
    },
    horaInicio(tms) {
      const mouse = this.toTime(tms);

      if (this.dragEvent && this.dragTime === null) {
        const { start } = this.dragEvent;

        const startMs = typeof start === 'number' ? start : Date.parse(start);

        if (Number.isNaN(mouse) || Number.isNaN(startMs)) {
          console.warn('Timestamp inválido', { tms, startMs });
          return;
        }

        this.dragTime = mouse - startMs;
      }
    },
    movimentarMouse(tms) {
      const mouse = this.toTime(tms);
      if (this.dragEvent && this.dragTime !== null && this.dragStartCoords) {
        const { clientX, clientY } = tms.nativeEvent || {};
        if (clientX != null && clientY != null) {
          const direcaox = Math.abs(clientX - this.dragStartCoords.x);
          const direcaoy = Math.abs(clientY - this.dragStartCoords.y);

          if (direcaox > 0 || direcaoy > 0) {
            this.arrastando = true;
            this.habilitarInfoAgendamento = false;


            if (!this.ghost) {
              const start = new Date(typeof this.dragEvent.start === 'number'
                ? this.dragEvent.start
                : Date.parse(this.dragEvent.start));
              const end = new Date(typeof this.dragEvent.end === 'number'
                ? this.dragEvent.end
                : Date.parse(this.dragEvent.end));

              this.events = this.events.filter((e) => !e._ghost);
              // cria o evento fantasma com mesmo start/end do real
              this.ghost = {
                ...JSON.parse(JSON.stringify(this.dragEvent)),
                id: '__ghost__',
                _ghost: true,
                start,
                end,
              };
              this.events.push(this.ghost);
            }
          }
        }
      }
      if (!this.arrastando || !this.dragEvent) return;

      if (this.dragTime !== null) {
        const { start } = this.dragEvent;
        const startMs = typeof start === 'number' ? start : Date.parse(start);
        const { end } = this.dragEvent;
        const endMs = typeof end === 'number' ? end : Date.parse(end);
        const duracao = endMs - startMs;
        const novoHorarioInicio = mouse - this.dragTime;
        const novaDataInicio = new Date(novoHorarioInicio);
        this.snappedStart = this.roundTime(novaDataInicio, this.intervalMinutes);
        const horarioInicialParaVerificaoString = toIsoLocal(this.snappedStart.getTime());
        const horarioInicialParaVerificaoDate = new Date(horarioInicialParaVerificaoString);
        const h = horarioInicialParaVerificaoDate.getHours().toString().padStart(2, '0');
        const m = horarioInicialParaVerificaoDate.getMinutes().toString().padStart(2, '0');
        this.horaAgendamentoStr = `${h}:${m}`;
        const novoHorarioFim = new Date(this.snappedStart.getTime() + duracao);
        this.ghost.start = toIsoLocal(this.snappedStart.getTime());
        this.ghost.end = toIsoLocal(novoHorarioFim.getTime());
        this.ghost.horaAgendamento = this.horaAgendamentoStr;
      }
    },
    async finalArraste() {
      if (!this.arrastando && this.dragEvent) {
        this.showEvent({ event: this.dragEvent });

        this.dragTime = null;
        this.dragEvent = null;
        this.ghost = null;
        this.dragStartCoords = null;
        this.arrastando = false;
        this.habilitarInfoAgendamento = true;
        this.permitirReagendamento = true;
        return;
      }
      if (this.dragEvent !== null) {
        const inicioHorarioFinal = new Date(this.ghost?.start);
        const dataISO = inicioHorarioFinal.toISOString().split('T')[0];
        const fimHorarioFinal = new Date(this.ghost?.end);
        const inicioGhostMs = inicioHorarioFinal.getTime();
        const fimGhostMs = fimHorarioFinal.getTime();
        const dataAgendamentoStr = inicioHorarioFinal.toLocaleDateString('pt-BR', {
          weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
        });
        const validacoes = [
          {
            condicao: this.verificarSeHorarioEstaAntesDoMinimoParaArraste(this.snappedStart),
            mensagem: 'Não é possível reagendar o agendamento para horário anterior ao atual.',
          },
          {
            condicao: !this.horariosConfiguradosNoCalendario(this.horaAgendamentoStr, this.snappedStart),
            mensagem: 'O horário selecionado não está configurado na agenda.',
          },
          {
            condicao: this.temConflitoNoArraste(inicioGhostMs, fimGhostMs),
            mensagem: 'Já existe um agendamento neste horário.',
          },
          {
            condicao: this.verificarDatasBloqueadas(dataISO),
            mensagem: 'O horário selecionado está em um dia bloqueado.',
          },
          {
            condicao: this.verificarFeriados(dataISO),
            mensagem: 'O horário selecionado está em um dia de feriado.',
          },
        ];
        // eslint-disable-next-line no-restricted-syntax
        for (const v of validacoes) {
          if (v.condicao) {
            MensagemMixin(6000, 'warning', v.mensagem);
            this.resetarDrag();
            return;
          }
        }
        this.dragEvent.dataAgendamento = dataAgendamentoStr;
        this.dragEvent.start = toIsoLocal(inicioHorarioFinal.getTime());
        this.dragEvent.end = toIsoLocal(fimHorarioFinal.getTime());
        const h = inicioHorarioFinal.getHours().toString().padStart(2, '0');
        const m = inicioHorarioFinal.getMinutes().toString().padStart(2, '0');
        this.dragEvent.horaAgendamento = `${h}:${m}`;
        this.dragEvent.color = this.ghost?.color;
        const eventoCalendario = JSON.parse(JSON.stringify(this.dragEvent));
        eventoCalendario.situacaoAgendamento = this.converteSTRSituacaoAgendamentoEmEnum(this.dragEvent?.situacaoAgendamento);
        eventoCalendario.tipoAgendamento = this.converteSTRTipoAgendamentoEmEnum(this.dragEvent?.tipoAgendamento);
        eventoCalendario.dataAgendamento = dataISO;
        this.events = this.events.filter((e) => e !== this.ghost);
        if (this.permitirReagendamento) {
          await this.agendamentoService.atualizaAgendamentoDragEDropCalendario(eventoCalendario.id, eventoCalendario).then(() => {
            MensagemMixin(6000, 'success', `Paciente ${eventoCalendario.name} reagendado para ${dataAgendamentoStr} ás ${eventoCalendario.horaAgendamento}`);
          }).catch(() => {
            AlertaSimplesErro('Erro ao reagendar o agendamento', 'Ocorreu um erro ao tentar reagendar o agendamento. Por favor, tente novamente.');
          });
        }
      }
      this.dragTime = null;
      this.dragEvent = null;
      this.ghost = null;
      this.dragStartCoords = null;
      this.arrastando = false;
      this.habilitarInfoAgendamento = true;
      this.permitirReagendamento = true;
    },
    cancelarDrag() {
      if (this.ghost) {
        this.events = this.events.filter((e) => e !== this.ghost);
        this.ghost = null;
      }
      this.dragEvent = null;
      this.dragTime = null;
      AlertaSimplesErro('Erro ao reagendar o agendamento', 'O Agendamento foi solto fora da área válida do calendário.');
    },
    resetarDrag() {
      this.events = this.events.filter((e) => e !== this.ghost);
      this.dragTime = null;
      this.dragEvent = null;
      this.ghost = null;
      this.dragStartCoords = null;
      this.arrastando = false;
      this.habilitarInfoAgendamento = true;
      this.permitirReagendamento = true;
    },
    intervalosConflitam(inicioGhostMs: number, fimGhostMs: number, inicioEventoMs: number, fimEventoMs: number) {
      return inicioGhostMs < fimEventoMs && fimGhostMs > inicioEventoMs;
    },
    temConflitoNoArraste(inicioGhostMs: number, fimGhostMs: number) {
      return this.events.some((evt) => {
        if (this.dragEvent && evt.id === this.dragEvent.id) return false;
        if (evt._ghost) return false;
        if (!evt.start || !evt.end) return false;

        const inicioEventoMs = typeof evt.start === 'number'
          ? evt.start
          : new Date(evt.start).getTime();

        const fimEventoMs = typeof evt.end === 'number'
          ? evt.end
          : new Date(evt.end).getTime();

        return this.intervalosConflitam(
          inicioGhostMs,
          fimGhostMs,
          inicioEventoMs,
          fimEventoMs,
        );
      });
    },
    toTime(tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime();
    },
    roundTime(date, step = this.intervalMinutes) {
      const data = new Date(date);
      const minutes = data.getMinutes();
      const rounded = Math.round(minutes / step) * step;
      data.setMinutes(rounded, 0, 0);
      return data;
    },
    obterDataEHoraMinimaParaArraste() {
      const dateTimeAtual = new Date();

      const dateTimeArredondado = this.roundTime(dateTimeAtual, this.intervalMinutes);

      return dateTimeArredondado;
    },
    verificarSeHorarioEstaAntesDoMinimoParaArraste(date) {
      const min = this.obterDataEHoraMinimaParaArraste();
      return date.getTime() < min.getTime();
    },
    calcularMarginTopQuartoSheet(time: string, horario: any, minutesToPixels: any): string {
      const timeHour = time.substring(0, 2);
      const horaInicioHour = horario.horaInicio.substring(0, 2);
      const horaFimHour = horario.horaFim.substring(0, 2);

      if (timeHour === horaInicioHour && horaFimHour === horaInicioHour) {
        return `${minutesToPixels(horario.horaInicio.substring(3, 5))}px`;
      }

      return '0';
    },
    calcularAlturaQuartoSheet(time: string, horario: any, minutesToPixels: any): string {
      const timeHour = time.substring(0, 2);
      const horaInicioHour = horario.horaInicio.substring(0, 2);
      const horaFimHour = horario.horaFim.substring(0, 2);

      if (timeHour === horaInicioHour && horaFimHour === horaInicioHour) {
        const minutosInicio = parseInt(horario.horaInicio.substring(3, 5), 10);
        const minutosFim = parseInt(horario.horaFim.substring(3, 5), 10);
        return `${minutesToPixels(minutosFim - minutosInicio)}px`;
      }

      return '0%';
    },
    async obterCorTipoConsulta(tipoConsultaId: any | undefined) {
      if (!tipoConsultaId) {
        return '#84b6f4';
      }

      if (this.obterCorSelecionadaEvento[tipoConsultaId]) {
        return this.obterCorSelecionadaEvento[tipoConsultaId];
      }

      const tipoConsulta = await this.tipoConsultaService.obterPorId(tipoConsultaId);
      const color = tipoConsulta?.data?.cor || '#84b6f4';
      this.$set(this.obterCorSelecionadaEvento, tipoConsultaId, color);
      return color;
    },
    async obterNomeTipoConsulta(tipoConsultaId: number) {
      if (!tipoConsultaId) {
        return 'Tipo de Consulta não definido';
      }

      const tipoConsulta = await this.tipoConsultaService.obterPorId(tipoConsultaId);
      return tipoConsulta?.data?.descricao || 'Tipo de Consulta não definido';
    },
    async clickExcluirAgendamento() {
      const confirmarCancelamento = this.selectedEvent.situacaoAgendamento === 'Cancelado'
        ? await AlertaPerguntaSimOuNaoBooleano(
          'Deseja realmente excluir esse agendamento?',
          'O agendamento será excluído, essa ação é irreversível!',
        )
        : true;

      if (confirmarCancelamento) {
        await this.agendamentoService.Delete(this.selectedEvent.id).then(
          () => {
            this.modalVisualizarAgendamento = false;
            this.loading = true;
            this.$emit('buscaAgendamentos', this.value);
            MensagemMixin(3000, 'success', 'Agendamento foi descartado com sucesso');
            this.loading = false;
          },
          (err) => {
            AlertaSimplesErro('Aviso:', err);
          },
        );
      }
    },
    async carregarCoresAtendimentos() {
      const tiposUnicos = new Set<string>();

      this.events.forEach((evento: { nomeTipoConsulta: string, tipoAgendamento: string }) => {
        if (evento.tipoAgendamento === 'Compromisso') {
          tiposUnicos.add('Compromisso');
        } else {
          tiposUnicos.add(evento.nomeTipoConsulta);
        }
      });

      if (tiposUnicos.has('Compromisso') && !this.coresTiposConsulta.Compromisso) {
        this.coresTiposConsulta.Compromisso = '#84b6f4';
      }

      const promessas = Array.from(tiposUnicos)
        .filter((tipo) => tipo !== 'Compromisso' && !this.coresTiposConsulta[tipo])
        .map(async (tipo) => {
          const eventoDoTipo = this.events.find((ev: { nomeTipoConsulta: string }) => ev.nomeTipoConsulta === tipo);
          if (eventoDoTipo) {
            const tipoConsulta = await this.tipoConsultaService.obterPorId(eventoDoTipo.tipoConsultaId);
            return { tipo, cor: tipoConsulta?.data?.cor || '#84b6f4' };
          }
          return { tipo, cor: '#84b6f4' };
        });

      const resultados = await Promise.all(promessas);

      resultados.forEach(({ tipo, cor }) => {
        this.coresTiposConsulta[tipo] = cor;
      });
    },
    async gerarImpressoAgenda() {
      await this.$refs.ModalModeloImpressoPersonalizado.abrirModal();
      this.confirmarAssinatura = await this.buscarCertificadoDigitalUsuarioEConfirmarAssinatura();

      if (this.modeloCabecalhoRodapeId) {
        this.loading = true;

        const configuracao = {
          ConfiguracaoImpressoAgenda: {
            margemSuperior: 10,
            margemInferior: 10,
            margemDireita: 10,
            margemEsquerda: 10,
          },
          AgendaId: this.agenda.id,
          // eslint-disable-next-line no-nested-ternary
          PeriodoInicialDosAgendamentosPeloTypeDoCalendario: this.periodoInicialDosAgendamentosPeloTypeDoCalendario,
          PeriodoFinalDosAgendamentosPeloTypeDoCalendario: this.periodoFinalDosAgendamentosPeloTypeDoCalendario,
          modeloCabecalhoRodapeId: this.modeloCabecalhoRodapeId,
          confirmarAssinatura: this.confirmarAssinatura,
        };

        this.serviceImpresso.GerarImpressoAgenda(configuracao)
          .then((res: AxiosResponse<Blob>) => {
            if (res?.data) {
              const impressoAgenda = `ImpressoAgenda_${new Date().toLocaleDateString('pt-BR')}.pdf`;
              PdfHelper.baixarPdf(res.data, impressoAgenda);

              AlertaSimples('Sucesso!', 'O impresso da agenda foi gerado com sucesso', 'success');
            } else {
              AlertaSimplesErro('Erro ao Gerar Impresso Da Agenda', 'Nenhum dado foi recebido para gerar o impresso.');
            }
          })
          .catch(() => {
            AlertaSimplesErro('Erro', 'Ocorreu um erro ao gerar o impresso.');
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    aoSalvarModelo(idSelecionado: number) {
      this.modeloCabecalhoRodapeId = idSelecionado;
    },
    async buscarCertificadoDigitalUsuarioEConfirmarAssinatura(): Promise<boolean> {
      const userId = decode(getToken()).id;

      return this.usuarioService.getCertificadoDigitalDoUsuario(userId)
        .then(async (res) => {
          if (!res?.data) return false;
          if (res.data.assinarDocumento === PromptAssinatura.PerguntarAntesDeAssinar) {
            const confirmarAssinatura = await AlertaPerguntaConfirmacaoBooleano(
              'O impresso gerado será enviado para o serviço de assinatura digital do Medsystem Cloud e será assinado com o certificado cadastrado no submenu Usuários, na colapse: Configurar Certificado Digital para Assinaturas.',
              'Deseja assinar digitalmente o impresso?',
            );
            return confirmarAssinatura;
          }

          return false;
        })
        .catch(() => {
          AlertaSimplesErro('Atenção', 'Não foi possível verificar o certificado digital do usuário.');
          return false;
        });
    },
    obterAgendamentosDoDia(date: Date) {
      const dataDia = new Date(date).toISOString().split('T')[0];
      return this.events.filter((evento: { start: string; isBloqueioHorario?: boolean; tipoAgendamento?: string; isColetivoGroup?: boolean }) => {
        const dataEvento = evento.start.includes('T') ? evento.start.split('T')[0] : evento.start.split(' ')[0];
        if (evento.tipoAgendamento === 'Coletivo' && !evento.isColetivoGroup) {
          return false;
        }
        return dataEvento === dataDia && !evento.isBloqueioHorario;
      })
        .sort((a, b) => a.horaAgendamento.localeCompare(b.horaAgendamento));
    },
    obterBloqueiosHorarioDoDia(date: Date) {
      const dataDia = new Date(date).toISOString().split('T')[0];
      const bloqueios = this.events.filter((evento: { start: string; isBloqueioHorario?: boolean }) => {
        const dataEvento = evento.start.split(' ')[0];
        return dataEvento === dataDia && evento.isBloqueioHorario;
      })
        .sort((a, b) => a.horarioInicio.localeCompare(b.horarioInicio));
      return bloqueios;
    },
    formatarNomeTipoBloqueio(tipoBloqueio: number): string {
      const tipos: { [key: number]: string } = {
        0: 'Almoço',
        1: 'Reunião',
        2: 'Consulta Externa',
        3: 'Treinamento',
        4: 'Procedimento',
        5: 'Intervalo',
        6: 'Outro',
      };
      return tipos[tipoBloqueio] || 'Bloqueio';
    },
    calcularHorarioFim(data: string, horarioInicio: string, duracao: string): string {
      const dataBase = data.split('T')[0];
      const [horaInicio, minutoInicio] = horarioInicio.split(':').map(Number);
      const [horaDuracao, minutoDuracao] = duracao.split(':').map(Number);

      const totalMinutosInicio = horaInicio * 60 + minutoInicio;
      const totalMinutosDuracao = horaDuracao * 60 + minutoDuracao;
      const totalMinutosFim = totalMinutosInicio + totalMinutosDuracao;

      const horaFim = Math.floor(totalMinutosFim / 60);
      const minutoFim = totalMinutosFim % 60;

      const horarioFim = `${horaFim.toString().padStart(2, '0')}:${minutoFim.toString().padStart(2, '0')}`;
      return `${dataBase} ${horarioFim}`;
    },
    calcularDuracao(start: string, end: string): string {
      if (!start || !end) {
        return '00:00';
      }

      const startDate = new Date(start);
      const endDate = new Date(end);

      if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
        return '00:00';
      }

      const diffMs = endDate.getTime() - startDate.getTime();
      const diffMinutes = Math.floor(diffMs / (1000 * 60));

      const horas = Math.floor(diffMinutes / 60);
      const minutos = diffMinutes % 60;

      return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
    },
    minutosDesdeMeiaNoite(horaString: string): number {
      const [h, m] = horaString.split(':').map(Number);
      return h * 60 + m;
    },

    intervaloParaMinutos(intervalo: string): number {
      const [h, m] = intervalo.split(':').map(Number);
      return h * 60 + m;
    },

    async onRefreshAgendamentosColetivo() {
      try {
        this.loading = true;
        const response = await this.agendamentoService.buscarAgendamentos(this.value);
        await this.montarEventos(response.data);
        if (this.modalVisualizarAgendamentoColetivo && this.selectedColetivoEvent) {
          const dataBaseSelecionada = this.selectedColetivoEvent.dataAgendamento;
          const horaBaseSelecionada = this.selectedColetivoEvent.horaAgendamento;
          const coletivoAtualizado = this.events.find(
            (evt) => evt.tipoAgendamento === 'Coletivo' && evt.isColetivoGroup
            && evt.dataAgendamento === dataBaseSelecionada && evt.horaAgendamento === horaBaseSelecionada,
          );
          if (coletivoAtualizado) {
            this.selectedColetivoEvent = { ...coletivoAtualizado };
            this.dialogKey++;
          }
        }
      } catch (error) {
        console.error('Erro ao atualizar agendamentos coletivos:', error);
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.altura {
  height: calc(100vh - 170px);
}

.calendario-header-row {
  flex-wrap: wrap;
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

.v-event-timed-container {
  margin-right: 0px;
}

.v-calendar-daily__day-interval {
  background-color: var(--cor-de-fundo) !important;
}

.v-calendar-weekly__day {
  height: 8rem !important;
  max-height: none !important;
  overflow: visible;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.menu-card {
  background-color: #f5f5f5 !important;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  max-width: 520px;
}

p {
  margin-bottom: 8px;
  font-size: 13px;
}

.v-menu__content {
  box-shadow: none;
}

.bolinha-indicador {
  width: 0.7rem;
  height: 0.8rem;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  cursor: pointer;
}

.bolinha-indicador-bloqueio {
  width: 0.7rem;
  height: 0.8rem;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
  cursor: not-allowed;
  border: 2px solid #c62828;
}

.v-calendar-weekly {
  height: 60rem;
}

.bolinha-indicador-container {
  display: flex;
  align-items: center;
  margin: 0;
  width: 16%;
  min-width: 0.8rem;
}

.day-cell {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  max-height: 100%;
  overflow-y: auto;
  padding: 4px;
  gap: 4px;
}

.texto-atendimentos {
  font-size: 0.8rem;
  color: #424242;
  font-weight: bold;
  margin-left: 1;
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.icone-excluir-agendamento {
  cursor: pointer;
  position: absolute;
  right: 6px;
}

.event-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 4px;
  cursor: grab;
  overflow: hidden;
  box-shadow: none !important;
  transition: all .2s ease;
  background: rgb(214 201 202);
  min-height: 27px;
  align-items: center;
}

.bloqueio-horario-event {
  background-color: #ffcdd2 !important;
  border-left: 4px solid #d32f2f !important;
  cursor: not-allowed !important;
}

.bloqueio-horario-event .event-title {
  color: #d32f2f !important;
  font-weight: bold;
}

.event-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.event-title {
  font-size: 0.9rem;
  line-height: 1.2;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
}

.event-details {
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-size: 0.75rem;
  color: #ffffff;
  flex-wrap: nowrap;
  overflow: hidden;
}

.event-details-bloqueio {
  color: #c62828 !important;
}

.event-details-bloqueio .event-detail {
  color: #c62828 !important;
}

.event-details-bloqueio strong {
  color: #b71c1c !important;
}

.event-detail {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 33%;
}

.event-observacao {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 33%;
}

.with-scroll {
  max-height: 110px;
  overflow-y: auto;
  padding-right: 2px;
}

.with-scroll::-webkit-scrollbar {
  width: 4px;
}

.with-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

@media (max-width: 1280px) {
  .altura {
    height: calc(100vh - 200px);
  }

  .v-calendar-weekly {
    height: calc(100vh - 230px);
  }

  .calendario-header {
    padding: 8px 12px !important;
  }
}

@media (max-width: 960px) {
  .altura {
    height: calc(100vh - 220px);
  }

  .v-calendar-weekly {
    height: calc(100vh - 250px);
  }

  .calendario-header-row {
    flex-direction: column;
  }

  .calendario-header .v-col {
    justify-content: center !important;
    margin-bottom: 8px;
  }

  .event-title {
    font-size: 0.8rem;
  }

  .event-details,
  .event-detail,
  .event-observacao {
    font-size: 0.7rem;
  }
}

.theme--dark {
  .calendario-header {
    background-color: #424242 !important;
  }
}
</style>
